export default { sha: 'fd0e1deee79d8ae4079bb303a983834a505ad403', buildNumber: 'undefined' }
